import { Injectable } from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {ApiService} from '../../../../core/service/api.service';

@Injectable()
export class ResponseConfigDelayService {

  constructor(private api:ApiService) { }

    getRespConfigDelay(criteria): Observable<any> {
        return this.api.get('vna/response-delay-config',criteria);
    }

    postRespConfigDelay(element: Object): Observable<any> {
        return this.api.post('vna/response-delay-config', element);
    }
    removeRespConfigDelay(pk: any): Observable<any> {
        return this.api.remove('vna/response-delay-config', pk);
    }
    putRespConfigDelay(element: any): Observable<any> {
        return this.api.put('vna/response-delay-config',element.pk,element);
    }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/config/vna_portal/services/response-config-delay.service.ts